import { defineComponent as _defineComponent } from 'vue'
interface ModalCloseButtonEmits {
  (event: 'click'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCloseButton',
  emits: ["click"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'click'): void;
}), expose: any, slots: any, attrs: any }) {



return { __sfc: true,emits }
}

})